<template>
  <div class="container-one">
    <PreviewStream
      :frameNo="props.frameNo"
      :instanceKey="previewStreamKey"
      @request-reset="onPreviewReset" />
  </div>
  <v-fade-transition>
    <div
      v-if="cuedScene"
      class="cue-preview-title"
      :style="'background: ' + deluge.frames[frameNo].color">
      <v-icon>
        {{ 'mdi-chevron-right-circle' }}
      </v-icon>
      <p>Cue Preview</p>
    </div>
  </v-fade-transition>
</template>
<script setup>
import { deluge } from '@/stores/deluge.js';
import PreviewStream from '../PreviewStream.vue';
import { computed, ref } from 'vue';
const props = defineProps(['frameNo']);
const previewStreamKey = ref(0);

// Prevent thrashing: rate-limit how often the parent will bump the key
// in response to child reset requests.
const PREVIEW_RESET_COOLDOWN = 3000;
let _lastPreviewReset = 0;
function onPreviewReset() {
  const now = Date.now();
  if (now - _lastPreviewReset < PREVIEW_RESET_COOLDOWN) return;
  _lastPreviewReset = now;
  previewStreamKey.value++;
}
const cuedScene = computed(() => {
  if (deluge.new_cued_dids) {
    const cuedDid = deluge.new_cued_dids[props.frameNo];
    if (!cuedDid) return null;
    const scene = deluge.items[cuedDid];
    return scene;
  }

  return null;
});
</script>
<style scoped>
.container-one {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
}

.cue-preview-title {
  width: min-content;
  height: min-content;
  white-space: nowrap;
  padding: 8px;
  position: absolute;
  top: 12px;
  left: 12px;
  border-radius: 5px;
  color: white;
  border-color: rgba(255, 255, 255, 0.08);
  border-style: solid;
  border-width: 1px;
  display: flex;
  gap: 8px;
}

@media only screen and (max-width: 550px) {
  .container-one {
    position: relative;
  }
}
</style>
